import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
// import './assets/css/bootstrap.min.css';
import './assets/css/font-awesome.min.css';
import './assets/css/global.scss';
import './assets/css/app.scss';
import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';
import 'moment/locale/fi';
import 'moment/locale/id';

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback="...">
      <App />
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
